// extracted by mini-css-extract-plugin
export default {"container":"ResultTransactionUnit_container__PnEr9","sad_container":"ResultTransactionUnit_sad_container__lSGa3","return_btn":"ResultTransactionUnit_return_btn__lhFlC"};